(function () {
  'use strict';

  if (window.__woodarqPdpV2StabilityBooted) {
    if (window.WoodarqPdpV2Stability && typeof window.WoodarqPdpV2Stability.refresh === 'function') {
      window.WoodarqPdpV2Stability.refresh('duplicate-load');
    }
    return;
  }

  window.__woodarqPdpV2StabilityBooted = true;

  var ROOT = document.documentElement;
  var BODY_CLASS = 'is-pdp-v2-active';
  var PRODUCT_TEMPLATE_CLASS = 'template-product-pdp-v2';
  var HEADER_CLASS = 'woodarq-pdp-v2-header-final';
  var PDP_MARKER_SELECTOR = '[data-woodarq-pdp-v2-marker], [data-woodarq-pdp-v2-header-final-state]';
  var TAXI_VIEW_SELECTOR = '[data-taxi-view]';
  var HEADER_SELECTOR = '.main-header';
  var OVERLAY_SELECTORS = [
    '.page-transition',
    '.transition-overlay',
    '.global-transition',
    '#global-backdrop',
    '[data-page-transition]',
    '[data-taxi-transition]'
  ];

  var refreshScheduled = false;
  var internalScrollSystemRefresh = false;
  var mutationObserver = null;
  var revealObservers = [];
  var layoutResizeObserver = null;
  var activeLayoutObservedScope = null;
  var taxiCoreEventsBound = false;
  var mediaLoadWatchScope = null;
  var pendingMeasurementBursts = {};
  var attemptedScriptLoads = Object.create(null);
  var heroStickyRaf = null;
  var stickyRanges = [];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function isMobileViewport() {
    return window.matchMedia ? window.matchMedia('(max-width: 989px)').matches : (window.innerWidth || 0) <= 989;
  }

  function hasPdpV2Hero() {
    return !!document.querySelector('[data-woodarq-pdp-hero]');
  }

  function getViewportMetrics() {
    var viewport = window.visualViewport || null;
    return {
      width: viewport && viewport.width ? viewport.width : (window.innerWidth || document.documentElement.clientWidth || 0),
      height: viewport && viewport.height ? viewport.height : (window.innerHeight || document.documentElement.clientHeight || 0)
    };
  }

  function getStablePdpVh(reason) {
    var metrics = getViewportMetrics();
    var candidate = Math.round(Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0, metrics.height || 0));
    var reset = /orientation|pageshow|ready|load/.test(String(reason || ''));

    if (!window.__woodarqPdpStableViewportHeight || reset) {
      window.__woodarqPdpStableViewportHeight = candidate;
      return candidate;
    }

    var previous = Number(window.__woodarqPdpStableViewportHeight) || candidate;
    var activeElement = document.activeElement;
    var calculatorInputFocused = !!(activeElement && activeElement.closest && activeElement.closest('[data-calculator-modal]'));
    var keyboardLikelyOpen = calculatorInputFocused || (metrics.height > 0 && previous > 0 && metrics.height < previous - 90);

    if (!keyboardLikelyOpen && candidate > previous + 12) {
      window.__woodarqPdpStableViewportHeight = candidate;
      return candidate;
    }

    return previous;
  }

  function forceMobileNativePdpScroll(reason) {
    if (!isMobileViewport() || !hasPdpV2Hero()) return false;

    var stableHeight = getStablePdpVh(reason);
    if (stableHeight > 0) {
      ROOT.style.setProperty('--vh', stableHeight + 'px');
      ROOT.style.setProperty('--wd-pdp-stable-viewport-height', stableHeight + 'px');
    }

    ROOT.classList.add('wd-pdp-mobile-native-scroll');
    if (document.body) {
      document.body.classList.add('wd-pdp-mobile-native-scroll');
      document.body.classList.remove('is-smooth');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('height');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow-y');
      document.body.style.removeProperty('touch-action');
    }

    toArray(document.querySelectorAll('[data-taxi-view], main[data-taxi], .app')).forEach(function (el) {
      if (!el || !el.style) return;
      el.style.removeProperty('height');
      el.style.removeProperty('min-height');
      el.style.removeProperty('max-height');
      el.style.removeProperty('transform');
      el.style.removeProperty('translate');
      el.style.removeProperty('position');
      el.style.removeProperty('top');
      el.style.removeProperty('left');
      el.style.removeProperty('right');
      el.style.removeProperty('bottom');
    });

    toArray(document.querySelectorAll('[data-woodarq-pdp-hero] .wd-pdp__gallery-col, .woodarq-product-tabs__spec-media')).forEach(function (el) {
      if (!el || !el.style) return;
      el.style.removeProperty('--wd-pdp-hero-sticky-offset');
      el.style.removeProperty('--wpt-spec-sticky-offset');
      el.style.removeProperty('transform');
    });

    return true;
  }

  function getActiveTaxiView() {
    var views = toArray(document.querySelectorAll(TAXI_VIEW_SELECTOR));
    if (!views.length) return null;

    var visibleViews = views.filter(function (view) {
      if (!view || !document.documentElement.contains(view)) return false;
      if (view.hidden || view.getAttribute('aria-hidden') === 'true') return false;

      if (window.getComputedStyle) {
        var styles = window.getComputedStyle(view);
        if (styles.display === 'none' || styles.visibility === 'hidden') return false;
      }

      return true;
    });

    // Taxi can briefly keep both the old and new view in the DOM during a
    // transition. The last visible view is the current/incoming one in this
    // theme's renderer.
    return visibleViews[visibleViews.length - 1] || views[views.length - 1] || null;
  }

  function getActiveScope() {
    return getActiveTaxiView() || document;
  }

  function scopeHasPdpMarker(scope) {
    return !!(scope && scope.querySelector && scope.querySelector(PDP_MARKER_SELECTOR));
  }

  function isActivePdpV2() {
    var activeView = getActiveTaxiView();
    if (activeView) return scopeHasPdpMarker(activeView);
    return scopeHasPdpMarker(document);
  }

  function scopeHasPdpV2ProductTemplate(scope) {
    return !!(scope && scope.querySelector && scope.querySelector('[data-woodarq-pdp-hero]'));
  }

  function isActivePdpV2ProductTemplate() {
    var activeView = getActiveTaxiView();
    if (activeView) return scopeHasPdpV2ProductTemplate(activeView);
    return scopeHasPdpV2ProductTemplate(document);
  }

  function syncPageFlags() {
    var active = isActivePdpV2();
    var productTemplateActive = isActivePdpV2ProductTemplate();

    if (active) forceMobileNativePdpScroll('sync-flags');
    else {
      ROOT.classList.remove('wd-pdp-mobile-native-scroll');
      if (document.body) document.body.classList.remove('wd-pdp-mobile-native-scroll');
    }

    ROOT.classList.toggle(HEADER_CLASS, active);
    if (document.body) {
      document.body.classList.toggle(BODY_CLASS, active);
      document.body.classList.toggle(PRODUCT_TEMPLATE_CLASS, productTemplateActive);
    }

    if (!active) {
      var header = document.querySelector(HEADER_SELECTOR);
      if (header) header.removeAttribute('data-wd-pdp-v2-contrast');
    }

    return active;
  }

  function hasOpenCalculatorModal() {
    return toArray(document.querySelectorAll('[data-calculator-modal]')).some(function (modal) {
      return modal && !modal.hidden && modal.getAttribute('aria-hidden') !== 'true';
    });
  }

  function shouldDeferRefreshForCalculator(reason) {
    if (!hasOpenCalculatorModal()) return false;
    reason = String(reason || '');
    return /^(visual-viewport|calculator-open|calculator-input|calculator-focus|calculator-blur)/.test(reason);
  }


  function cleanupNonPdpNavigationState(reason) {
    if (hasPdpV2Hero()) return;

    ROOT.classList.remove(
      'wd-pdp-mobile-native-scroll',
      'wd-pdp-modal-open',
      'wd-pdp-keyboard-open',
      'wd-pdp-calculator-page-locked'
    );

    if (document.body) {
      document.body.classList.remove(
        BODY_CLASS,
        PRODUCT_TEMPLATE_CLASS,
        'wd-pdp-mobile-native-scroll',
        'wd-pdp-modal-open',
        'wd-pdp-calculator-modal-open',
        'wd-pdp-keyboard-open',
        'wd-pdp-calculator-page-locked',
        'is-transitioning',
        'is-loading',
        'is-animating-out',
        'has-transition-overlay'
      );
      delete document.body.dataset.wdPdpLockedScrollTop;
    }

    [ROOT, document.body].forEach(function (el) {
      if (!el || !el.style) return;
      [
        'overflow',
        'overflow-y',
        'position',
        'top',
        'left',
        'right',
        'bottom',
        'width',
        'height',
        'max-height',
        'touch-action',
        'pointer-events'
      ].forEach(function (property) {
        el.style.removeProperty(property);
      });
    });

    toArray(document.querySelectorAll([
      'body > [data-wd-pdp-sticky-atc]',
      'body > .wd-pdp__sticky-atc',
      'body > [data-wd-pdp-viewport-modal]',
      'body > [data-wd-pdp-portal]',
      'body > [data-service-drawer][data-wd-pdp-viewport-modal]',
      'body > [data-calculator-modal][data-wd-pdp-viewport-modal]',
      'body > [data-delivery-zip-modal][data-wd-pdp-viewport-modal]'
    ].join(','))).forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });

    toArray(document.querySelectorAll('.app, main[data-taxi], [data-taxi-view]')).forEach(function (el) {
      if (!el || !el.style) return;
      el.style.removeProperty('pointer-events');
      el.style.removeProperty('overflow');
      el.style.removeProperty('overflow-y');

      if (el.matches && (el.matches('main[data-taxi]') || el.matches('[data-taxi-view]'))) {
        el.style.removeProperty('height');
        el.style.removeProperty('min-height');
        el.style.removeProperty('max-height');
        el.style.removeProperty('transform');
        el.style.removeProperty('translate');
      }

      if (el.style.visibility === 'hidden') el.style.removeProperty('visibility');
      if (el.style.opacity === '0') el.style.removeProperty('opacity');
    });

    try {
      if (typeof nt !== 'undefined' && nt) {
        if (nt.flags) nt.flags.isLocked = false;
        var activeView = getActiveTaxiView();
        if (activeView) nt.currentPage = activeView;
        if (nt.scroll && typeof nt.scroll.setScrollBounds === 'function') nt.scroll.setScrollBounds();
        if (nt.raf && typeof nt.raf.clamp === 'function') nt.raf.clamp();
      }
    } catch (error) {}

    try { window.dispatchEvent(new Event('scroll')); } catch (error) {}
  }

  function unlockStalePageState() {
    if (!document.body) return;

    document.body.classList.remove('is-transitioning', 'is-loading', 'is-animating-out', 'has-transition-overlay');
    document.body.style.removeProperty('pointer-events');
    forceMobileNativePdpScroll('unlock-stale');

    OVERLAY_SELECTORS.forEach(function (selector) {
      toArray(document.querySelectorAll(selector)).forEach(function (el) {
        var fixedOrAbsolute = false;
        if (window.getComputedStyle) {
          var position = window.getComputedStyle(el).position;
          fixedOrAbsolute = position === 'fixed' || position === 'absolute';
        }

        if (fixedOrAbsolute || el.id === 'global-backdrop') {
          el.style.pointerEvents = 'none';
        }
      });
    });
  }

  function splitChars(el) {
    if (!el || el.dataset.waSplitReady === 'true') return;

    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    el.dataset.waSplitReady = 'true';
    el.setAttribute('aria-label', text);
    el.textContent = '';

    for (var i = 0; i < text.length; i += 1) {
      var span = document.createElement('span');
      span.className = 'wa-char';
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--wa-char-index', i);
      span.textContent = text[i] === ' ' ? '\u00A0' : text[i];
      el.appendChild(span);
    }
  }


  function prepareProductTabsInteractions(scope) {
    scope = scope || getActiveScope() || document;
    var roots = toArray(scope.querySelectorAll ? scope.querySelectorAll('[data-woodarq-product-tabs]') : []);

    roots.forEach(function (root) {
      if (root.dataset.woodarqPdpV2TabsReady === 'true') return;
      root.dataset.woodarqPdpV2TabsReady = 'true';

      var tabs = toArray(root.querySelectorAll('[data-wpt-tab]'));
      var panels = toArray(root.querySelectorAll('[data-wpt-panel]'));
      if (!tabs.length || !panels.length) return;

      function activateTab(index, shouldFocus) {
        tabs.forEach(function (tab, tabIndex) {
          var isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach(function (panel, panelIndex) {
          var isActive = panelIndex === index;
          panel.classList.toggle('is-active', isActive);
          if (isActive) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', 'hidden');
        });

        window.requestAnimationFrame(function () {
          try {
            document.dispatchEvent(new CustomEvent('woodarq:product-tabs:change', {
              detail: { root: root, index: index }
            }));
          } catch (error) {}
          scheduleMeasurementBursts('product-tabs-change');
        });

        if (shouldFocus && tabs[index]) tabs[index].focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(index, false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = index === tabs.length - 1 ? 0 : index + 1;
          if (event.key === 'ArrowLeft') nextIndex = index === 0 ? tabs.length - 1 : index - 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== index) {
            event.preventDefault();
            activateTab(nextIndex, true);
          }
        });
      });
    });
  }

  function prepareRelatedProducts(scope) {
    toArray((scope || document).querySelectorAll('[data-wa-related-products]')).forEach(function (section) {
      section.querySelectorAll('[data-wa-split="chars"]').forEach(splitChars);

      toArray(section.querySelectorAll('.woodarq-related-products__card')).forEach(function (card, index) {
        card.style.setProperty('--wa-index', index);
        var image = card.querySelector('[data-wa-animate="image"]');
        if (image) image.style.setProperty('--wa-index', index);
      });

      section.classList.add('wa-animation-ready');
    });
  }

  function prepareComparison(scope) {
    toArray((scope || document).querySelectorAll('[data-woodarq-comparison]')).forEach(function (root) {
      toArray(root.querySelectorAll('[data-comparison-col], [data-comparison-row]')).forEach(function (el, index) {
        el.style.transitionDelay = Math.min(index * 0.08, 0.48) + 's';
      });
    });
  }

  function prepareHomeowners(scope) {
    toArray((scope || document).querySelectorAll('[data-woodarq-homeowners]')).forEach(function (root) {
      toArray(root.querySelectorAll('[data-homeowners-card]')).forEach(function (card, index) {
        card.style.setProperty('--homeowners-card-delay', 180 + index * 140 + 'ms');
      });

      toArray(root.querySelectorAll('[data-homeowners-text-reveal]')).forEach(function (item, index) {
        item.style.setProperty('--homeowners-text-delay', index * 95 + 'ms');
      });
    });
  }

  function isElementInRevealRange(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    return rect.top < vh * 0.92 && rect.bottom > vh * 0.02;
  }

  function revealRelatedTarget(target) {
    if (!target) return;
    target.classList.add('is-inview');

    if (target.classList.contains('woodarq-related-products__card')) {
      target.querySelectorAll('[data-wa-animate]').forEach(function (child) {
        child.classList.add('is-inview');
      });
    }
  }

  function revealVisible(target) {
    if (!target) return;
    target.classList.add('is-visible');
  }

  function disconnectRevealObservers() {
    revealObservers.forEach(function (observer) {
      if (observer && typeof observer.disconnect === 'function') observer.disconnect();
    });
    revealObservers = [];
  }

  function observeTargets(targets, revealFn, options) {
    targets = toArray(targets).filter(Boolean);
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(revealFn);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealFn(entry.target);
        observer.unobserve(entry.target);
      });
    }, options || { threshold: 0.14, rootMargin: '0px 0px -10% 0px' });

    targets.forEach(function (target) {
      if (isElementInRevealRange(target)) {
        revealFn(target);
      } else {
        observer.observe(target);
      }
    });

    revealObservers.push(observer);
  }

  function armFallbackRevealObservers(scope) {
    disconnectRevealObservers();

    observeTargets(
      (scope || document).querySelectorAll('[data-wa-related-products] [data-wa-animate]'),
      revealRelatedTarget,
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    observeTargets(
      (scope || document).querySelectorAll('[data-woodarq-comparison] [data-comparison-col], [data-woodarq-comparison] [data-comparison-row]'),
      revealVisible,
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    observeTargets(
      (scope || document).querySelectorAll('[data-woodarq-homeowners]'),
      revealVisible,
      { threshold: 0.22, rootMargin: '0px 0px -10% 0px' }
    );
  }

  function callIfAvailable(objectName, methodName, scope) {
    var api = window[objectName];
    if (api && typeof api[methodName] === 'function') {
      try {
        api[methodName](scope || document);
      } catch (error) {
        console.warn('Woodarq PDP v2 reinit failed for ' + objectName + '.' + methodName, error);
      }
    }
  }

  function getScriptName(src) {
    return String(src || '').split('?')[0].split('#')[0].split('/').pop();
  }

  function isCriticalScriptLoaded(name) {
    if (name === 'woodarq-pdp-hero.js') return !!(window.WoodarqPdpHero && window.WoodarqPdpHero.initAll);
    if (name === 'woodarq-shared-gallery.js') return !!(window.WoodarqSharedGallery && window.WoodarqSharedGallery.initAll);
    if (name === 'woodarq-customer-reviews.js') return !!(window.WoodarqCustomerReviews && window.WoodarqCustomerReviews.initAll);
    if (name === 'woodarq-faq-section.js') return !!(window.WoodarqFaqSection && window.WoodarqFaqSection.initAll);
    if (name === 'woodarq-still-need-help.js') return !!(window.WoodarqStillNeedHelp && window.WoodarqStillNeedHelp.initAll);
    return true;
  }

  function ensureCriticalSectionScripts(scope) {
    var criticalNames = {
      'woodarq-pdp-hero.js': true,
      'woodarq-shared-gallery.js': true,
      'woodarq-customer-reviews.js': true,
      'woodarq-faq-section.js': true,
      'woodarq-still-need-help.js': true
    };

    toArray((scope || document).querySelectorAll('script[src]')).forEach(function (script) {
      var src = script.getAttribute('src');
      var absoluteSrc = script.src || src;
      var name = getScriptName(src || absoluteSrc);

      if (!criticalNames[name]) return;
      if (isCriticalScriptLoaded(name)) return;
      if (attemptedScriptLoads[absoluteSrc] || attemptedScriptLoads[name]) return;

      attemptedScriptLoads[absoluteSrc] = true;
      attemptedScriptLoads[name] = true;

      var clone = document.createElement('script');
      clone.src = absoluteSrc;
      clone.defer = true;
      clone.onload = function () { scheduleRefresh('loaded-' + name, 30); };
      clone.onerror = function () { console.warn('Woodarq PDP v2 could not load ' + name); };
      document.head.appendChild(clone);
    });
  }

  function callSectionInitialisers(scope) {
    callIfAvailable('WoodarqPdpHero', 'initAll', scope);
    callIfAvailable('WoodarqSharedGallery', 'initAll', scope);
    callIfAvailable('WoodarqCustomerReviews', 'initAll', scope);
    callIfAvailable('WoodarqFaqSection', 'initAll', scope);
    callIfAvailable('WoodarqStillNeedHelp', 'initAll', scope);
  }

  function isSmoothDesktopPdpLayout() {
    return !!(
      document.body &&
      !ROOT.classList.contains('wd-pdp-mobile-native-scroll') &&
      document.body.classList.contains('is-smooth') &&
      window.matchMedia &&
      window.matchMedia('(min-width: 990px)').matches
    );
  }

  function isDesktopHeroStickyEnabled() {
    return isSmoothDesktopPdpLayout();
  }

  function resetPdpHeroSticky(scope) {
    toArray((scope || document).querySelectorAll('[data-woodarq-pdp-hero] .wd-pdp__gallery-col')).forEach(function (col) {
      removeCssVariable(col, '--wd-pdp-hero-sticky-offset');
    });
  }

  function getTranslateY(el) {
    if (!el || !window.getComputedStyle) return 0;

    var transform = window.getComputedStyle(el).transform;
    if (!transform || transform === 'none') return 0;

    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
      var values3d = matrix3d[1].split(',').map(function (value) { return parseFloat(value); });
      return values3d.length >= 16 && !isNaN(values3d[13]) ? values3d[13] : 0;
    }

    var matrix2d = transform.match(/^matrix\((.+)\)$/);
    if (matrix2d) {
      var values2d = matrix2d[1].split(',').map(function (value) { return parseFloat(value); });
      return values2d.length >= 6 && !isNaN(values2d[5]) ? values2d[5] : 0;
    }

    return 0;
  }

  function getOffsetTopWithin(child, ancestor) {
    var top = 0;
    var node = child;

    while (node && node !== ancestor && node instanceof HTMLElement) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }

    return top;
  }


  function getDocumentOffsetTop(el) {
    var top = 0;
    var node = el;

    while (node && node instanceof HTMLElement) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }

    return top;
  }

  function getViewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight || 900;
  }

  function measureStickyRanges(scope) {
    stickyRanges = [];

    if (!isSmoothDesktopPdpLayout()) return stickyRanges;

    scope = scope || getActiveScope();
    var viewportHeight = getViewportHeight();
    var buffer = viewportHeight * 1.2;

    toArray(scope.querySelectorAll('[data-woodarq-pdp-hero]')).forEach(function (hero) {
      var top = getDocumentOffsetTop(hero);
      var height = hero.offsetHeight || 0;
      if (height > 0) {
        stickyRanges.push({ start: top - buffer, end: top + height + buffer });
      }
    });

    toArray(scope.querySelectorAll('[data-woodarq-product-tabs]')).forEach(function (tabs) {
      var panel = tabs.querySelector('.woodarq-product-tabs__panel-inner--specifications');
      var media = tabs.querySelector('.woodarq-product-tabs__spec-media');
      if (!panel || !media || isHiddenPanel(panel)) return;

      var top = getDocumentOffsetTop(panel);
      var height = panel.offsetHeight || tabs.offsetHeight || 0;
      if (height > 0) {
        stickyRanges.push({ start: top - buffer, end: top + height + buffer });
      }
    });

    return stickyRanges;
  }

  function shouldRunStickyUpdates() {
    if (!isSmoothDesktopPdpLayout()) return false;
    if (!stickyRanges.length) measureStickyRanges(getActiveScope());
    if (!stickyRanges.length) return false;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    var viewportHeight = getViewportHeight();
    var viewportStart = scrollTop;
    var viewportEnd = scrollTop + viewportHeight;

    for (var i = 0; i < stickyRanges.length; i += 1) {
      var range = stickyRanges[i];
      if (viewportEnd >= range.start && viewportStart <= range.end) return true;
    }

    return false;
  }

  function setCssPixelVariable(el, name, value, threshold) {
    if (!el) return;

    var precision = threshold && threshold >= 0.75 ? 1 : 100;
    var next = Math.round((value || 0) * precision) / precision;
    var current = parseFloat(el.style.getPropertyValue(name));
    var tolerance = typeof threshold === 'number' ? threshold : 0.35;

    if (!isNaN(current) && Math.abs(current - next) <= tolerance) return;

    el.style.setProperty(name, next + 'px');
  }

  function removeCssVariable(el, name) {
    if (!el) return;
    if (el.style.getPropertyValue(name)) el.style.removeProperty(name);
  }

  function updatePdpHeroSticky(scope) {
    scope = scope || document;

    if (!isDesktopHeroStickyEnabled()) {
      resetPdpHeroSticky(scope);
      return;
    }

    toArray(scope.querySelectorAll('[data-woodarq-pdp-hero]')).forEach(function (hero) {
      var col = hero.querySelector('.wd-pdp__gallery-col');
      if (!col) return;

      var currentScroll = Math.max(0, -getTranslateY(hero));
      var stickyTop = parseFloat(window.getComputedStyle(col).top) || 24;
      var naturalTop = getOffsetTopWithin(col, hero);
      var start = Math.max(0, naturalTop - stickyTop);
      var maxOffset = Math.max(0, hero.offsetHeight - naturalTop - col.offsetHeight - stickyTop);
      var offset = Math.min(Math.max(0, currentScroll - start), maxOffset);

      setCssPixelVariable(col, '--wd-pdp-hero-sticky-offset', offset, 0.2);
    });
  }

  function resetProductTabsSpecSticky(scope) {
    toArray((scope || document).querySelectorAll('.woodarq-product-tabs__spec-media')).forEach(function (media) {
      removeCssVariable(media, '--wpt-spec-sticky-offset');
    });
  }

  function getSpecStickyTop() {
    var width = window.innerWidth || document.documentElement.clientWidth || 1440;
    return Math.min(150, Math.max(96, width * 0.08));
  }

  function getSpecStickyBottomGap() {
    var width = window.innerWidth || document.documentElement.clientWidth || 1440;
    return Math.min(160, Math.max(50, width * 0.05));
  }

  function readCssPixelValue(element, propertyName) {
    if (!element) return 0;
    var raw = element.style.getPropertyValue(propertyName);
    var value = parseFloat(raw);
    return isNaN(value) ? 0 : value;
  }

  function isHiddenPanel(panel) {
    if (!panel) return true;
    if (panel.hidden || panel.getAttribute('aria-hidden') === 'true') return true;
    var owner = panel.closest('[role="tabpanel"]');
    return !!(owner && (owner.hidden || owner.getAttribute('aria-hidden') === 'true'));
  }

  function updateProductTabsSpecSticky(scope) {
    scope = scope || document;

    if (!isSmoothDesktopPdpLayout()) {
      resetProductTabsSpecSticky(scope);
      return;
    }

    toArray(scope.querySelectorAll('[data-woodarq-product-tabs]')).forEach(function (tabs) {
      var panel = tabs.querySelector('.woodarq-product-tabs__panel-inner--specifications');
      var media = tabs.querySelector('.woodarq-product-tabs__spec-media');

      if (!panel || !media || isHiddenPanel(panel)) {
        removeCssVariable(media, '--wpt-spec-sticky-offset');
        return;
      }

      var panelRect = panel.getBoundingClientRect();
      var mediaRect = media.getBoundingClientRect();
      var mediaNaturalTop = panelRect.top + getOffsetTopWithin(media, panel);
      var stickyTop = getSpecStickyTop();
      var stickyBottomGap = getSpecStickyBottomGap();
      var lowerBound = mediaNaturalTop;
      var upperBound = panelRect.bottom - stickyBottomGap - mediaRect.height;

      if (upperBound <= lowerBound) {
        setCssPixelVariable(media, '--wpt-spec-sticky-offset', 0, 0.75);
        return;
      }

      var desiredTop = Math.min(Math.max(lowerBound, stickyTop), upperBound);
      var offset = Math.max(0, desiredTop - mediaNaturalTop);

      // Keep the smooth-scroll sticky shim on whole-pixel values only. This avoids
      // the constant sub-pixel style churn that was making the page/DevTools flash
      // while still keeping the left spec image visually pinned during scroll.
      setCssPixelVariable(media, '--wpt-spec-sticky-offset', offset, 0.75);
    });
  }

  function startPdpHeroStickyLoop(duration, shouldMeasure) {
    if (shouldMeasure) measureStickyRanges(getActiveScope());
    if (heroStickyRaf) return;

    var tick = function () {
      heroStickyRaf = null;

      if (!isActivePdpV2()) {
        resetPdpHeroSticky(document);
        resetProductTabsSpecSticky(document);
        stickyRanges = [];
        return;
      }

      var activeScope = getActiveScope();
      var shouldUpdateSticky = shouldRunStickyUpdates();

      if (!isSmoothDesktopPdpLayout()) {
        resetPdpHeroSticky(activeScope);
        resetProductTabsSpecSticky(activeScope);
      } else if (shouldUpdateSticky) {
        updatePdpHeroSticky(activeScope);
        updateProductTabsSpecSticky(activeScope);
      }

      if (shouldUpdateSticky) {
        heroStickyRaf = window.requestAnimationFrame(tick);
      }
    };

    heroStickyRaf = window.requestAnimationFrame(tick);
  }


  function getScopedSmoothElements(scope) {
    scope = scope || getActiveScope() || document;
    var elems = [];

    try {
      if (scope.matches && scope.matches('.data-smooth')) elems.push(scope);
      elems = elems.concat(toArray(scope.querySelectorAll ? scope.querySelectorAll('.data-smooth') : []));
    } catch (error) {}

    return elems;
  }

  function isSameNodeOrContains(parent, child) {
    return !!(parent && child && (parent === child || (parent.contains && parent.contains(child))));
  }

  function getBundleCurrentPage() {
    try {
      if (typeof nt !== 'undefined' && nt && nt.currentPage) return nt.currentPage;
    } catch (error) {}
    return null;
  }

  function isRendererSyncedWithActiveView(renderer, activeView) {
    if (!activeView) return false;

    var bundlePage = getBundleCurrentPage();
    if (bundlePage && bundlePage !== activeView) return false;

    if (!renderer) return true;
    if (renderer.content && renderer.content !== activeView) return false;

    return true;
  }

  function ensureVisibleTaxiContent(scope) {
    if (!scope || !isActivePdpV2()) return;

    forceMobileNativePdpScroll('ensure-visible');

    var els = [];
    var app = scope.closest ? scope.closest('.app') : document.querySelector('.app');
    if (app) els.push(app);
    els.push(scope);

    var view = getActiveTaxiView();
    if (view && els.indexOf(view) === -1) els.push(view);

    els.forEach(function (el) {
      if (!el || !el.style) return;
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.pointerEvents = '';
    });
  }

  function resetNativeScrollContainers() {
    forceMobileNativePdpScroll('reset-native-scroll-containers');
    try {
      var app = document.querySelector('.app');
      if (app && typeof app.scrollTop === 'number') app.scrollTop = Math.min(app.scrollTop, Math.max(0, app.scrollHeight - app.clientHeight));
    } catch (error) {}
  }

  function scheduleMeasurementBursts(reason) {
    reason = reason || 'measure';
    var key = String(reason).replace(/[^a-z0-9:_-]/gi, '_');
    if (pendingMeasurementBursts[key]) return;
    pendingMeasurementBursts[key] = true;

    [0, 120, 320, 700, 1250].forEach(function (delay) {
      window.setTimeout(function () {
        scheduleRefresh(reason + '-burst-' + delay, 0);
      }, delay);
    });

    window.setTimeout(function () {
      delete pendingMeasurementBursts[key];
    }, 1500);
  }

  function observeActiveLayout(scope) {
    if (!scope || !window.ResizeObserver) return;
    if (layoutResizeObserver && activeLayoutObservedScope === scope) return;

    try {
      if (layoutResizeObserver) layoutResizeObserver.disconnect();
    } catch (error) {}

    activeLayoutObservedScope = scope;
    layoutResizeObserver = new ResizeObserver(function () {
      if (!isActivePdpV2()) return;
      scheduleRefresh('active-layout-resize', 90);
    });

    try {
      layoutResizeObserver.observe(scope);
      var hero = scope.querySelector('[data-woodarq-pdp-hero]');
      if (hero) layoutResizeObserver.observe(hero);
      var tabs = scope.querySelector('[data-woodarq-product-tabs]');
      if (tabs) layoutResizeObserver.observe(tabs);
    } catch (error) {}
  }

  function disconnectActiveLayoutObserver() {
    activeLayoutObservedScope = null;
    if (!layoutResizeObserver) return;
    try { layoutResizeObserver.disconnect(); } catch (error) {}
    layoutResizeObserver = null;
  }

  function watchActiveMediaLoad(scope) {
    if (!scope || mediaLoadWatchScope === scope) return;
    mediaLoadWatchScope = scope;

    var media = toArray(scope.querySelectorAll ? scope.querySelectorAll('img, video, iframe') : []);
    media.forEach(function (el) {
      if (el.dataset.woodarqPdpV2MediaWatched === 'true') return;
      el.dataset.woodarqPdpV2MediaWatched = 'true';

      var onReady = function () {
        scheduleMeasurementBursts('media-ready');
      };

      if ((el.tagName === 'IMG' && el.complete) || (el.tagName === 'VIDEO' && el.readyState >= 1)) return;
      el.addEventListener('load', onReady, { once: true, passive: true });
      el.addEventListener('loadedmetadata', onReady, { once: true, passive: true });
      el.addEventListener('error', onReady, { once: true, passive: true });
    });
  }

  function bindTaxiCoreEvents() {
    if (taxiCoreEventsBound) return true;

    try {
      if (typeof nt === 'undefined' || !nt || !nt.taxi || typeof nt.taxi.on !== 'function') return false;

      taxiCoreEventsBound = true;

      nt.taxi.on('NAVIGATE_OUT', function () {
        disconnectRevealObservers();
        disconnectActiveLayoutObserver();
      });

      nt.taxi.on('NAVIGATE_IN', function () {
        scheduleMeasurementBursts('taxi:NAVIGATE_IN');
        window.setTimeout(function () { cleanupNonPdpNavigationState('taxi:NAVIGATE_IN'); }, 120);
      });

      nt.taxi.on('NAVIGATE_END', function () {
        scheduleMeasurementBursts('taxi:NAVIGATE_END');
        window.setTimeout(function () { cleanupNonPdpNavigationState('taxi:NAVIGATE_END'); }, 80);
        window.setTimeout(function () { cleanupNonPdpNavigationState('taxi:NAVIGATE_END-follow-up'); }, 320);
      });

      return true;
    } catch (error) {}

    return false;
  }

  function waitForTaxiCoreEvents() {
    if (bindTaxiCoreEvents()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (bindTaxiCoreEvents() || tries > 30) window.clearInterval(timer);
    }, 150);
  }

  function getCurrentTaxiRenderer() {
    try {
      if (typeof nt === 'undefined' || !nt || !nt.taxi) return null;
      if (nt.taxi.currentCacheEntry && nt.taxi.currentCacheEntry.renderer) return nt.taxi.currentCacheEntry.renderer;
      if (nt.taxi.renderer) return nt.taxi.renderer;
    } catch (error) {}

    return null;
  }

  function reasonNeedsSmoothSectionUpdate(reason) {
    reason = String(reason || '');
    return /^(ready|ready-follow-up|load|pageshow|pageshow-follow-up|pageshow-bfcache|resize|orientationchange|product-tabs-change|taxi:|pjax:|turbo:|shopify:|duplicate-load|loaded-|manual|media-ready|active-layout-resize)/.test(reason) || /-burst-/.test(reason);
  }

  function refreshSmoothSections(reason, scope) {
    if (!reasonNeedsSmoothSectionUpdate(reason)) return;

    try {
      var activeView = getActiveTaxiView();
      var renderer = getCurrentTaxiRenderer();
      if (!isRendererSyncedWithActiveView(renderer, activeView)) {
        scheduleRefresh((reason || 'refresh') + '-renderer-sync', 180);
        return;
      }

      if (renderer && renderer.smooth && typeof renderer.smooth.update === 'function') {
        var elems = getScopedSmoothElements(scope || activeView || document);
        renderer.smooth.update(elems.length ? elems : undefined);
      }
    } catch (error) {}
  }

  function refreshScrollSystems(reason) {
    if (internalScrollSystemRefresh) {
      scheduleRefresh((reason || 'refresh') + '-queued', 190);
      return;
    }

    internalScrollSystemRefresh = true;

    var activeView = getActiveTaxiView();
    var scope = getActiveScope();
    ensureVisibleTaxiContent(scope || activeView);
    resetNativeScrollContainers();

    // Avoid both synthetic window resize and the theme's resize event bus here.
    // The bus wakes every resize subscriber and was causing visible page flashing
    // when DevTools/device simulation was open. These direct smooth-scroll calls
    // are enough to update scroll bounds without re-running the whole theme.
    try {
      if (typeof nt !== 'undefined' && nt) {
        refreshSmoothSections(reason, scope || activeView);
        if (nt.scroll && typeof nt.scroll.setScrollBounds === 'function' && isRendererSyncedWithActiveView(getCurrentTaxiRenderer(), activeView)) nt.scroll.setScrollBounds();
        if (nt.raf && typeof nt.raf.clamp === 'function') nt.raf.clamp();
      }
    } catch (error) {}

    try {
      window.dispatchEvent(new Event('scroll'));
    } catch (error) {}

    if (reasonNeedsSmoothSectionUpdate(reason) && window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      try { window.ScrollTrigger.refresh(true); } catch (error) { window.ScrollTrigger.refresh(); }
    }

    window.setTimeout(function () {
      internalScrollSystemRefresh = false;
    }, 110);
  }

  function dispatchReinitEvent(scope, reason) {
    try {
      document.dispatchEvent(new CustomEvent('woodarq:pdp-v2:reinit', {
        detail: {
          reason: reason || 'refresh',
          scope: scope || document
        }
      }));
    } catch (error) {}
  }

  function refresh(reason) {
    refreshScheduled = false;
    unlockStalePageState();
    forceMobileNativePdpScroll(reason || 'refresh');

    if (shouldDeferRefreshForCalculator(reason)) {
      syncPageFlags();
      return;
    }

    if (!syncPageFlags()) {
      cleanupNonPdpNavigationState(reason || 'non-pdp-refresh');
      disconnectRevealObservers();
      disconnectActiveLayoutObserver();
      refreshScrollSystems(reason || 'non-pdp-refresh');
      return;
    }

    var scope = getActiveScope();
    ensureVisibleTaxiContent(scope);
    observeActiveLayout(scope);
    watchActiveMediaLoad(scope);

    prepareProductTabsInteractions(scope);
    prepareRelatedProducts(scope);
    prepareComparison(scope);
    prepareHomeowners(scope);
    ensureCriticalSectionScripts(scope);
    callSectionInitialisers(scope);
    stickyRanges = [];
    updatePdpHeroSticky(scope);
    updateProductTabsSpecSticky(scope);
    startPdpHeroStickyLoop(1200, true);
    armFallbackRevealObservers(scope);
    dispatchReinitEvent(scope, reason);
    refreshScrollSystems(reason);

    window.setTimeout(function () {
      if (!syncPageFlags()) return;
      var activeScope = getActiveScope();
      ensureVisibleTaxiContent(activeScope);
      observeActiveLayout(activeScope);
      watchActiveMediaLoad(activeScope);
      prepareProductTabsInteractions(activeScope);
      callSectionInitialisers(activeScope);
      stickyRanges = [];
      updatePdpHeroSticky(activeScope);
      updateProductTabsSpecSticky(activeScope);
      startPdpHeroStickyLoop(900, true);
      refreshScrollSystems(reason);
    }, 260);
  }

  function scheduleRefresh(reason, delay) {
    if (refreshScheduled) return;
    refreshScheduled = true;

    var run = function () {
      window.requestAnimationFrame(function () { refresh(reason); });
    };

    if (delay && delay > 0) window.setTimeout(run, delay);
    else run();
  }

  function mutationNodeNeedsRefresh(node) {
    if (!node || node.nodeType !== 1) return false;

    var el = node;
    var importantSelector = [
      TAXI_VIEW_SELECTOR,
      PDP_MARKER_SELECTOR,
      'main',
      '#MainContent',
      '.shopify-section',
      'script[src]'
    ].join(',');

    if (el.matches && el.matches(importantSelector)) return true;
    return !!(el.querySelector && el.querySelector(importantSelector));
  }

  function shouldRefreshForMutations(mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      var nodes = toArray(mutation.addedNodes).concat(toArray(mutation.removedNodes));

      for (var j = 0; j < nodes.length; j += 1) {
        if (mutationNodeNeedsRefresh(nodes[j])) return true;
      }
    }

    return false;
  }

  function observeDom() {
    if (!document.body || mutationObserver) return;

    mutationObserver = new MutationObserver(function (mutations) {
      if (!shouldRefreshForMutations(mutations)) return;
      scheduleRefresh('dom-mutation', 80);
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.WoodarqPdpV2Stability = {
    refresh: function (reason) { scheduleRefresh(reason || 'manual', 0); },
    refreshMeasurements: function (reason) { scheduleMeasurementBursts(reason || 'manual'); },
    fixMobileScrollGap: function (reason) { forceMobileNativePdpScroll(reason || 'manual-fix'); },
    isActive: isActivePdpV2,
    getActiveScope: getActiveScope
  };

  ready(function () {
    observeDom();
    waitForTaxiCoreEvents();
    scheduleRefresh('ready', 0);
    scheduleMeasurementBursts('ready');
    window.setTimeout(function () { scheduleRefresh('ready-follow-up', 0); }, 650);
  });

  window.addEventListener('pageshow', function (event) {
    var reason = event && event.persisted ? 'pageshow-bfcache' : 'pageshow';
    scheduleRefresh(reason, 0);
    scheduleMeasurementBursts(reason);
    window.setTimeout(function () { scheduleRefresh('pageshow-follow-up', 0); }, 450);
  });

  ['load', 'popstate', 'hashchange', 'focus', 'resize', 'orientationchange'].forEach(function (eventName) {
    window.addEventListener(eventName, function () {
      if (eventName === 'resize' && internalScrollSystemRefresh) return;
      var delay = eventName === 'resize' ? 120 : (eventName === 'popstate' ? 260 : 0);
      scheduleRefresh(eventName, delay);
      if (eventName === 'load' || eventName === 'orientationchange') scheduleMeasurementBursts(eventName);
    }, { passive: true });
  });

  ['lazyloaded', 'lazybeforeunveil', 'shopify:section:select'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      scheduleMeasurementBursts(eventName);
    }, { passive: true });
  });

  document.addEventListener('woodarq:pdp-v2:viewport-refresh', function (event) {
    var reason = event && event.detail && event.detail.reason ? event.detail.reason : 'viewport-refresh';
    scheduleRefresh(reason, 0);
    scheduleMeasurementBursts(reason);
  });

  if (window.visualViewport) {
    ['resize', 'scroll'].forEach(function (eventName) {
      window.visualViewport.addEventListener(eventName, function () {
        forceMobileNativePdpScroll('visual-viewport-' + eventName);
        if (hasOpenCalculatorModal()) return;
        scheduleRefresh('visual-viewport-' + eventName, eventName === 'resize' ? 80 : 140);
      }, { passive: true });
    });
  }

  window.addEventListener('scroll', function () {
    // The PDP hero/spec-image sticky shims are only needed around their own
    // sections. Do not keep a permanent layout-reading RAF alive across the
    // whole page, because it makes the lower PDP sections scroll/jitter.
    startPdpHeroStickyLoop(700, false);
  }, { passive: true });

  [
    'taxi:render',
    'taxi:load',
    'taxi:after-render',
    'taxi:after-load',
    'pjax:complete',
    'turbo:load',
    'shopify:section:load',
    'shopify:section:reorder'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () { scheduleRefresh(eventName, 30); });
  });
}());
